import Moment from 'moment'

const MomentFormat = {
    
    // 获取今天日期
    getToday: function () {
        return Moment().format('YYYY-MM-DD');
    },
    
    // 获取昨天日期
    getYestoday: function () {
        return Moment().subtract(Moment.duration(1, 'd')).format('YYYY-MM-DD');
    },

    // 获取前第七天日期
    getSevenDate: function () {
        return Moment().subtract(Moment.duration(7, 'd')).format('YYYY-MM-DD');
    },

    // 获取前第三十天日期
    getThirtyDate: function () {
        return Moment().subtract(Moment.duration(30, 'd')).format('YYYY-MM-DD');
    }
    
};

module.exports = MomentFormat;


// WEBPACK FOOTER //
// ./src/views/dataPlatform/filters/moment-format.js